var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.contact/app/contact/form/contact-avatar-modal.pug");
module.exports = (req['default'] || req).apply(req, [])